import Api from "../commom/api";

const validatorAPI = async (evseID: string) => {
    const response = await Api.get<boolean>('/evse/' + evseID + '/validate/')

    return response.data
}

export {validatorAPI}
